import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndexCategory } from "../model/OrganisationIndexCategory";
import OrganisationIndexCategoryMapper from "../service/OrganisationIndexCategoryMapper";
import OrganisationIndexCategoryParamMapper from "../service/OrganisationIndexCategoryParamMapper";

export default class GetIndexCategoriesForAllOrganisationsInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisationIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(categoryTypeId: number) {
    return this.resource.execute(
      `organisations/index-categories/${categoryTypeId}/all`,
      OrganisationIndexCategoryMapper,
      OrganisationIndexCategoryParamMapper
    );
  }
}
